export { BvlCheckboxComponent as BvlCheckbox } from './checkbox.component';
export { BvlCheckboxModule } from './checkbox.module';